export default __webpack_public_path__ + "static/media/stud_billing_icon_white.ed3d7eb9.svg";